<!-- src/views/profile/index.vue -->
<template>
  <div>
    Profile
  </div>
</template>

<script setup></script>

<style scoped></style>